module.exports = __webpack_public_path__ + "img/pubgm-code_tip1.369881b.png";